import { versionToJson } from '../../machineapp_utils';
import { ApplicationTypes, InjectableMachineAppApplication } from '../../../machinelogic';
import { MachineLogicAppBuilder } from '../../../legacy/machinelogic_app_builder';
import machine_app_implementation_loader from '../machine_app_implementation_loader';

export function MachineAppApplication(pLibrary, pType, pUuid, pName, pVersion, pAppData, pInjectedAppJson, pVid) {
  if (!pInjectedAppJson) {
    pInjectedAppJson = generateDefaultAppJson(pLibrary.getManager().getMachineLogicLibrary(), pName, pType);
  }

  this.mLibrary = pLibrary;
  this.mType = pType;
  this.mUuid = pUuid;
  this.mName = pName;
  this.mAppData = pAppData || {};
  this.mInjectedApplication = new InjectableMachineAppApplication(
    pLibrary.getManager().getMachineLogicLibrary(),
    this,
    pInjectedAppJson
  );
  this.mVersion = pVersion;

  this.mVid = pVid; // Cad-Only
}

function generateDefaultAppJson(pMachineLogicLibrary, pName, pType) {
  // If we are creating an injectable app from scratch, we need to build the first-time JSON with injectable points filled in.
  const lAppBuilder = new MachineLogicAppBuilder(pMachineLogicLibrary);
  const lBuildableApp = lAppBuilder.createApp(pName);
  const lDefaultSeq = lAppBuilder.createSequence('Main Sequence');
  lBuildableApp.addSequence(lDefaultSeq);
  lBuildableApp.setMainSequence(lDefaultSeq);

  const lInjectablePointsList = machine_app_implementation_loader.instance.getInjectablePointList(pType);
  lInjectablePointsList.forEach(function(pInjectablePoint) {
    const lDefaultInjectableSeq = lAppBuilder.createSequence(pInjectablePoint.name, {isLocked : true});
    lBuildableApp.addSequence(lDefaultInjectableSeq);
    lDefaultSeq.addInstruction(
      lAppBuilder.instructions.trigger.execute({ sequenceName: pInjectablePoint.name })
    );
  });

  const lApp = lBuildableApp.generate(ApplicationTypes.GeneratedMachineApp);
  return lApp.toJson();
}

/**
 * @returns {MachineAppLibrary}
 */
MachineAppApplication.prototype.getLibrary = function () { return this.mLibrary; };
MachineAppApplication.prototype.setDirty = function (pOnSuccess, pOnError) { this.getLibrary().upsert(this.getItemType(), this, pOnSuccess, pOnError); };
MachineAppApplication.prototype.getType = function () { return this.mType; };
MachineAppApplication.prototype.getUuid = function () { return this.mUuid; };
MachineAppApplication.prototype.getVid = function () { return this.mVid; }; // Cad-Only
MachineAppApplication.prototype.getName = function () { return this.mName; };
MachineAppApplication.prototype.setName = function (pName) {
  this.mName = this.mLibrary.uniqueApplicationName(pName);
  this.mInjectedApplication.mName = this.mName;
  this.setDirty();
};
MachineAppApplication.prototype.getAppData = function () { return this.mAppData; };
MachineAppApplication.prototype.setAppData = function (pAppData) { this.mAppData = pAppData; this.setDirty(); };
MachineAppApplication.prototype.isActive = function () { return false; };
MachineAppApplication.prototype.getItemType = function () { return 'application'; };
MachineAppApplication.prototype.getInjectableApplication = function () { return this.mInjectedApplication; };
MachineAppApplication.prototype.setInjectableApplication = function (pJson, pCompletion) { this.setDirty(pCompletion); };
MachineAppApplication.prototype.toJson = function () {
  return {
    type: this.getType(),
    uuid: this.getUuid(),
    name: this.getName(),
    version: versionToJson(this.mVersion),
    appData: this.getAppData(),
    injectedAppJson: this.mInjectedApplication?.toJson() || undefined,
    vid: this.mVid,
    itemType: this.getItemType()
  };
};
